const COOKIE_CONSENT_KEY = "cookieConsentSettings";

export const defaultConsent = {
  necessary: true,
  analytics: false,
  functional: false,
  marketing: false,
  externalMedia: false,
  consentGiven: false,
  updatedAt: null,
};

export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    return {
      ...defaultConsent,
      ...parsed,
      necessary: true,
    };
  } catch (error) {
    console.error("Failed to read cookie consent:", error);
    return null;
  }
};

export const saveConsent = (consent) => {
  try {
    const payload = {
      ...defaultConsent,
      ...consent,
      necessary: true,
      consentGiven: true,
      updatedAt: new Date().toISOString(),
    };

    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
    window.dispatchEvent(new Event("cookie-consent-updated"));
  } catch (error) {
    console.error("Failed to save cookie consent:", error);
  }
};

export const acceptAllConsent = () => {
  saveConsent({
    analytics: true,
    functional: true,
    marketing: true,
    externalMedia: true,
  });
};

export const rejectAllConsent = () => {
  saveConsent({
    analytics: false,
    functional: false,
    marketing: false,
    externalMedia: false,
  });
};

export const hasConsentBeenGiven = () => {
  const consent = getStoredConsent();
  return Boolean(consent?.consentGiven);
};
